module.exports = __webpack_public_path__ + "static/CircularPro-Black.a51fdea1.ttf";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-Black.ttf
// module id = 712
// module chunks = 168707334958949